export default {
	bizInspectCalWarn: {
		// 标题和按钮
		alarmRecord: '报警记录',
		alarmStatistics: '报警统计',
		export: '导出',
		ignore: '忽略',
		confirm: '确认',
		details: '详情',
		generateReport: '生成报告',
		cancel: '取消',
		ok: '确定',

		// 表单标签
		deviceName: '设备名称',
		deviceNo: '设备编号',
		orgName: '所属部门',
		status: '状态',
		alarmTime: '告警时间',
		alarmLevel: '告警等级',
		alarmCount: '告警次数',
		alarmTitle: '告警标题',
		startTime: '开始时间',
		endTime: '结束时间',
		handleStatus: '处理状态',
		type: '告警分类',

		// 表单 placeholder
		selectProcessor: '选择处理人',
		processSuggestion: '处理建议',
		selectAlarmType: '告警分类',
		selectAlarmLevel: '告警等级',
		selectHandleStatus: '处理状态',

		// 对话框标题
		selectTimeRange: '选择时间范围',
		confirmAlarm: '确认告警',
		generateReportTitle: '生成报告',

		// 提示信息
		confirmIgnore: '是否忽略此条告警？',
		reportGenerating: '正在生成报告，请稍候...',
		reportSuccess: '报告生成成功！',
		reportFailed: '报告生成失败，请稍后重试',
		reportTimeout: '报告生成时间较长，请稍后刷新页面查看',
		operationSuccess: '操作成功',
		requiredField: '必填项不能为空',

		// 状态文本
		running: '运行',
		stop: '停机',
		offline: '离线',
		normal: '正常',
		general: '一般',
		medium: '中等',
		severe: '严重',

		// 其他
		gridLayout: '格栅布局',
		parameterType: '参数类型',
		parameterValue: '参数值',
		parameterDesc: '参数描述',

		// 报警统计对话框
		alarmStatisticsTitle: '报警统计',
		filterConditions: '筛选条件',
		department: '所属部门',
		dateRange: '日期',
		to: '至',
		startDate: '开始日期',
		endDate: '结束日期',
		query: '查询',
		reset: '重置',
		statisticsResult: '统计结果',
		prealarmTotal: '预报警总数',
		diagnosisTotal: '诊断总数',
		incorrectAlarm: '报警不正确',
		correctAlarm: '报警正确',
		incorrectDiagnosis: '诊断不正确',
		correctDiagnosis: '诊断正确',
		unconfirmedAlarm: '未复核报警',
		unconfirmedDiagnosis: '未复核诊断',
		noData: '暂无数据',
		prealarmStatistics: '预报警统计',
		diagnosisStatistics: '诊断报警统计',

		// list-warn 组件
		deviceInfoPanel: '设备信息面板',
		unknownDevice: '未知设备',
		pointList: '测点列表',
		alarmInfo: '告警信息',
		alarmType: '告警类型',
		currentPoint: '当前测点',
		content: '内容',
		markFilter: '标记过滤',
		filterDisplay: '过滤显示',
		showAll: '全部显示',
		batchConfirm: '批量确认',
		batchIgnore: '批量忽略',
		batchDelete: '批量删除',
		alarmId: '告警id',
		push: '推送',
		eigenValue: '特征值',
		referenceValue: '参考值',
		actualValue: '实际值',
		aiModelNote: 'AI 模型生成，仅供参考',
		modelConfig: '模型配置',
		processSuggestionInput: '处理建议输入',
		pleaseInputSuggestion: '请输入处理建议',
		diagnose: '诊断',
		configure: '配置',
		delete: '删除',
		review: '复核',
		reviewResult: '复核结果',
		diagnoseCorrect: '诊断是否正确',
		correct: '正确',
		incorrect: '不正确',
		modelType: '模型类型',
		ignoreSuccess: '忽略成功',
		confirmSuccess: '确认成功',
		configSuccess: '配置成功',
		noConfigFound: '未找到配置信息',
		noImage: '暂无图片',
		prompt: '提示',
		suggestion: '建议'
	}
}
